// extracted by mini-css-extract-plugin
export default {"n1":"feed_n1__idRmO"};